import styled from "@emotion/styled";
import { breakpoints, colors, fontSizes, fontWeights, gutterSizes, mediaQuery } from "@gumtree/ui-library/src/base/theme";

export const SimpleHeaderContainer = styled.div`
    width: 100%;
    background-color: ${colors.blade};
    box-sizing: border-box;
    ${mediaQuery.until(breakpoints.small)} {
        padding: 0 ${gutterSizes.medium};
    }
`;

export const SimpleHeader = styled.div`
    height: 60px;
    max-width: 1142px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    position: relative;
    ${mediaQuery.until(breakpoints.small)} {
        max-width: 100%;
    }
`;

export const BackButton = styled.div`
    width: fit-content;
    height: 24px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: ${colors.white};
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.normal};
    position: absolute;
    left: 0;
`;
